<script>
  import { VDialog } from 'vuetify/lib'

  export default {
    name: 'BaseDialog',

    extends: VDialog,
  }
</script>
